import { css } from '@/styled-system/css';

export const responsiveContainerStyles = css.raw({
  margin: 'auto',
  maxWidth: { base: '1232px', sm: '100%', lg: '1232px' },
  paddingLeft: { base: '200', lg: '600', xxl: '0' },
  paddingRight: { base: '200', lg: '600', xxl: '0' },
  justifyContent: 'space-between',
  alignItems: 'center',
  display: 'flex',
  height: { base: '55px', lg: '81px' },
  position: 'relative',
});
